<template>
  <div
    :class="$style.badgeInfo"
  >
    <div>
      <Icon
        :class="$style.premiumIcon"
        icon="premiumDiscover"
        :scale="1.25"
      />
      <span>Based on your feature usage we recommend:</span>
      <ul :class="$style.listContainer">
        <li
          v-for="recommendation in recommendations"
          :key="recommendation"
        >
          <MarkdownInline
            :mdTemplate="recommendation"
          />
        </li>
      </ul>
    </div>
    <div :class="$style.linkContainer">
      <Button
        :class="$style.premiumFeatureUsageLinkText"
        data-test-id="premiumPlusFeatureBadge__learnMoreLink"
        hasNoBackground
        text="Learn About Plan Options"
        @click="handleLearnMoreClick"
      />
    </div>
  </div>
</template>

<script>
import { Button, Icon, MarkdownInline } from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  section,
  text,
  toUrl,
} = eventProperties;

export default {
  name: 'RecommendedPackageBadge',
  components: {
    Button,
    Icon,
    MarkdownInline,
  },

  Util,

  props: {
    recommendedAddOns: {
      type: Array,
      default: () => [],
    },
    recommendedPackage: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    recommendations() {
      const recommendations = [];

      if (this.recommendedPackage.displayName) {
        recommendations.push(`Upgrading to **${this.recommendedPackage.displayName}**`);
      }

      this.recommendedAddOns.forEach((recommendedAddOn) => {
        recommendations.push(`Adding **${recommendedAddOn.displayName}**`);
      });

      return recommendations;
    },
  },

  methods: {
    handleLearnMoreClick() {
      EventHelper.triggerLinkClicked({
        [description]: 'Opens link to the upgrade tab.',
        [location]: eventLocations.upgradePage,
        [section]: 'Plan Information',
        [text]: 'Learn About Plan Options',
        [toUrl]: ItemTypeRoutes[ItemTypeConsts.accountUpgrade],
      });

      this.$options.Util.redirect(ItemTypeRoutes[ItemTypeConsts.accountUpgrade]);
    },
  },
};

</script>

<style scoped module>
.badgeInfo {
  background: var(--badge-background, var(--jc-color-disabled-fill));
  background-color: var(--jcTertiary50);
  color: var(--jc-text-color-dark);
  display: flex;
  font-size: var(--jcBody);
  font-weight: 500;
  gap: var(--jc-spacer-small);
  line-height: var(--jc-spacer-large);
  padding: var(--jc-spacer-small);
}

@media (max-width: 740px) {
  .badgeInfo {
    display: none;
  }
}

button.premiumFeatureUsageLinkText {
  color: var(--jc-color-informational-strong);
  text-decoration: underline;
}

.linkContainer {
  align-items: flex-end;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  padding: 8px;
}

.listContainer {
  margin-bottom: 0;
}

.premiumIcon.premiumIcon {
  bottom: var(--jc-spacer-negative-x-small);
  height: 1.5em;
  justify-content: center;
  padding: 4px;
}
</style>
